import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'vanilla-autofill-event';

import '../sections/product';

import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

// React for the ajax cart
import React from 'react';
import ReactDOM from 'react-dom';

import jQuery from 'jquery';

import {pageLinkFocus} from '@shopify/theme-a11y';
import {cookiesEnabled} from '@shopify/theme-cart';
import {wrapTable, wrapIframe} from '@shopify/theme-rte';
import smoothscroll from 'smoothscroll-polyfill';

// playa javascript
import form from '../templates/customers/form';
import CartDrawer from '../components/cart-drawer';
import Subscription from '../templates/customers/subscription';
import slideshows from '../components/slideshows';
import blog from '../components/blog';
import scroll from './scroll';
import quickview from '../components/quick_view';

// Default slate window objects
window.slate = window.slate || {};
window.theme = window.theme || {};

// Reassigning jQuery since some plugins require this
window.$ = window.jQuery = jQuery;

// Initiallize prior to "DOM Loaded" to ensure mustache templates are overridden
Subscription();
smoothscroll.polyfill();

$(document).ready(() => {
  $('body').addClass('page-loaded');

  let ignore_onbeforeunload = false;
  $('a[href^=mailto]').on('click',function(){
      ignore_onbeforeunload = true;
  });

  $(window).on("beforeunload", function(e) {
    if (!ignore_onbeforeunload){
      $('body').addClass('page-out').removeClass('page-loaded');
    } else {
      ignore_onbeforeunload = false;
    }
  });

  // Setup React
  ReactDOM.render(
    <CartDrawer mailer={window.playa_mailer} />,
    document.getElementById('root')
  );

  blog();

  scroll();

  // Initialize form helper
  form();

  // Common a11y fixes
  if (window.location.hash !== '#' && window.location.hash !== '') {
    pageLinkFocus($(window.location.hash));
  }

  $('.back-to-top').on('click', function(e){
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  })

  // Init slideshows
  slideshows();

  $('.in-page-link').on('click', (evt) => {
    pageLinkFocus($(evt.currentTarget.hash));
  });

  let $mobileNavPanel      = $('.mobile-nav-wrapper');
  let $mobileNavPanelBtn   = $('.mobile-menu-btn-js');
  let $mobileNavPanelClose = $('.mobile-nav_close-js');

  $mobileNavPanelBtn.on('click', function(e){
    e.preventDefault();
    $mobileNavPanel.addClass('open');
  });

  $mobileNavPanelClose.on('click', function(e) {
    e.preventDefault();
    $mobileNavPanel.removeClass('open');
  });

  // Target tables to make them scrollable
  const tableSelectors = '.rte table';

  wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies',
    );
  }

  // quickviews
  quickview();
});
